export default __webpack_public_path__ + "static/media/480_private01-it-web.5d4a9cae.png";